export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      filter += `(nome like '%${state.searchText.toLowerCase()}%' or grupoCompra.nome like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
